// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"5b70e64f","832":"4e39c336","850":"3257e5b4"}[chunkId] + ".chunk.css";
};